import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideBar from "../components/common/Sidebar/SideBar";
import Logout from "../components/common/Logout/Logout";
import "./admin-responsive.css";

/**
 * Admin shell. On wide screens the menu is a fixed column; below 992px it becomes an off-canvas drawer opened
 * with the hamburger in the top bar (closes on navigation, on backdrop tap and on Escape).
 */
const MainLayout = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.classList.toggle("admin-menu-open", open);
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.classList.remove("admin-menu-open");
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="admin-shell">
      <SideBar />
      <div className="admin-backdrop" onClick={() => setOpen(false)} />
      <div className="app-content content">
        <div className="admin-topbar">
          <button
            type="button"
            className="admin-burger"
            aria-label="منو"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`bx ${open ? "bx-x" : "bx-menu"}`}></i>
          </button>
          <Logout />
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
